import { ERROR_CODE_MANAGEMENT } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IErrorCodeManagementRepository } from "features/errorCodeManagement/domain/repositories/IErrorCodeManagementRepository";
import { injectable } from "tsyringe";
import { ErrorCodeActionRequestModel } from "./model/actions/ErrorCodeActionRequestModel";
import { ErrorCodeRequestModel } from "./model/ErrorCodeRequestModel";
import { ErrorCodeResponseModel } from "./model/ErrorCodeResponseModel";

@injectable()
export class ErrorCodeManagementImpl implements IErrorCodeManagementRepository {
  async getList(
    params: ErrorCodeRequestModel,
  ): Promise<ListBaseApiResponseModel<ErrorCodeResponseModel>> {
    return await client?.get(ERROR_CODE_MANAGEMENT?.LIST, params);
  }

  async getDetail(
    params: ErrorCodeRequestModel,
  ): Promise<BaseApiResponseModel<ErrorCodeResponseModel>> {
    return await client?.get(
      `${ERROR_CODE_MANAGEMENT?.DETAIL}/${params?.code}`,
      {},
    );
  }

  async updateErrorCode(
    body: ErrorCodeActionRequestModel,
  ): Promise<BaseApiResponseModel<ErrorCodeResponseModel>> {
    const queryCode = body?.code;
    delete body?.code;
    return await client?.put(
      `${ERROR_CODE_MANAGEMENT?.UPDATE}/${queryCode}`,
      body,
    );
  }

  async createErrorCode(
    body: ErrorCodeActionRequestModel,
  ): Promise<BaseApiResponseModel<ErrorCodeResponseModel>> {
    return await client?.post(ERROR_CODE_MANAGEMENT?.CREATE, body);
  }

  async deleteErrorCode(params: {
    code: string;
  }): Promise<BaseApiResponseModel<ErrorCodeResponseModel>> {
    return await client?.delete(
      `${ERROR_CODE_MANAGEMENT?.DELETE}/${params?.code}`,
      {},
    );
  }
}
